import { useEffect, useState } from "react";
import { assetUrl, useSettings } from "../../utils/useContent";
import SubscribeForm from "../SubscribeForm/SubscribeForm";
import "./PopupModal.css";

const STORAGE_KEY = "asx_popup_v1_seen";

const DEFAULTS = {
  "popup.enabled": "false",
  "popup.heading": "Stay in the loop",
  "popup.subheading":
    "Subscribe to get updates on upcoming leagues, tournaments, and events.",
  "popup.image_path": "",
};

export default function PopupModal() {
  const settings = useSettings("popup.", DEFAULTS);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const enabled = settings["popup.enabled"] === "true";
  const heading = settings["popup.heading"];
  const subheading = settings["popup.subheading"];
  const imagePath = settings["popup.image_path"];

  useEffect(() => {
    if (!enabled) return;
    const alreadySeen = !!localStorage.getItem(STORAGE_KEY);
    if (!alreadySeen) {
      const t = setTimeout(() => setOpen(true), 900);
      return () => clearTimeout(t);
    }
    setDismissed(true);
  }, [enabled]);

  const close = () => {
    setOpen(false);
    setDismissed(true);
    localStorage.setItem(STORAGE_KEY, "1");
  };

  if (!enabled) return null;

  return (
    <>
      {open && (
        <div className="pm-backdrop" onClick={close} role="dialog" aria-modal="true" aria-label="Newsletter signup">
          <div className="pm-modal" onClick={(e) => e.stopPropagation()}>
            {imagePath && (
              <div className="pm-left">
                <img src={assetUrl(imagePath)} alt="" />
              </div>
            )}
            <div className={`pm-right${!imagePath ? " pm-right-full" : ""}`}>
              <button className="pm-close" onClick={close} aria-label="Close popup">
                ×
              </button>
              <div className="pm-content">
                <div className="pm-kicker">Newsletter</div>
                <h2 className="pm-heading">{heading}</h2>
                <p className="pm-sub">{subheading}</p>
                <SubscribeForm />
              </div>
            </div>
          </div>
        </div>
      )}

      {dismissed && !open && (
        <button className="pm-fab" onClick={() => setOpen(true)} aria-label="Open newsletter signup">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="m2 7 10 7 10-7" />
          </svg>
          <span>Newsletter</span>
        </button>
      )}
    </>
  );
}
